export default __webpack_public_path__ + "static/media/node-removebg-preview.b819cdb3.png";